import React from "react";
import { useLocation } from "react-router-dom";

import { BrandConstants } from "../app/constants/TextConstants";
import { fallbackPageTitle } from "./pageTitles";

export const ScrollToTop: React.FC<unknown> = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    // Each page gets a tab title; pages that set their own override it
    // (their effects run after this one). QA batch 16, NAV-023.
    const title = fallbackPageTitle(pathname);
    if (title) document.title = GetPageTitle(title);
  }, [pathname]);

  return null;
};

export const GetPageTitle = (title: string): string => {
  return `${title} | ${BrandConstants.name}`;
};
